import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, styled } from '@mui/system';
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import GenButton from './GenButton';
import 'swiper/swiper.min.css';

const PREFIX = 'PhotoGallery';

const classes = {
  swiperSlide: `${PREFIX}-swiperSlide`,
  nextButton: `${PREFIX}-nextButton`,
  prevButton: `${PREFIX}-prevButton`,
};

const BoxStyled = styled(Box)(({ theme }) => ({
  [`.${classes.swiperSlide}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  [`.${classes.nextButton}`]: {
    position: 'absolute',
    top: '50%',
    right: '0px',
    cursor: 'pointer',
    zIndex: '10',
    transform: 'translate(0, -22.5px)',
    background: 'rgba(255, 255, 255, 0.5)',
    borderRadius: '50%',
  },
  [`.${classes.prevButton}`]: {
    position: 'absolute',
    top: '50%',
    left: '0px',
    cursor: 'pointer',
    zIndex: '10',
    transform: 'translate(0, -22.5px)',
    background: 'rgba(255, 255, 255, 0.5)',
    borderRadius: '50%',
  },
}));

const PhotoGallery = ({ images, initialSlide = 1 }) => {
  const swiperRef = useRef();
  return images ? (
    <BoxStyled>
      <Swiper
        initialSlide={initialSlide}
        slidesPerView={1}
        loop={true}
        onBeforeInit={swiper => {
          swiperRef.current = swiper;
        }}
      >
        <Box className={classes.prevButton}>
          <GenButton
            iconForIconButton={<ChevronLeft color="action" fontSize="large" />}
            onClick={() => swiperRef.current?.slidePrev()}
            data-testid="photoGalleryPrevButton"
          />
        </Box>
        {images.map((el, i) => {
          return (
            <SwiperSlide className={classes.swiperSlide} key={i}>
              <Box
                component="img"
                src={el}
                alt="Car"
                sx={{ maxWidth: '100%', height: 'auto' }}
                data-testid={el}
              />
            </SwiperSlide>
          );
        })}
        <Box className={classes.nextButton}>
          <GenButton
            iconForIconButton={<ChevronRight color="action" fontSize="large" />}
            onClick={() => swiperRef.current.slideNext()}
            data-testid="photoGalleryNextButton"
          />
        </Box>
      </Swiper>
    </BoxStyled>
  ) : null;
};

export default PhotoGallery;
